import React from 'react';

import StarsWizard from '@swf/components/StarsWizard/StarsWizard';
import useCMSHeaderAndGridLayout from '@swf/core/hooks/useCMSHeaderAndGridLayout';

import Deposit from '../Deposit/Deposit';
import FirstLoader from '../FirstLoader/FirstLoader';

import RMF from './RMF';

const RMFWizard = () => {
  const cmsHeaderAndGridLayout = useCMSHeaderAndGridLayout();

  return (
    <StarsWizard
      flow={[RMF, Deposit]}
      loader={<FirstLoader />}
      cmsHeaderAndGridLayout={cmsHeaderAndGridLayout}
    >
      <RMF />
      <Deposit />
    </StarsWizard>
  );
};

export default RMFWizard;
